import { Autosuggest } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function TempleKioskPicker({ kiosksState, kiosksActions }) {
  const { t } = useTranslation()

  const authorizedKiosks = kiosksState.kioskSuggestions?.filter((kiosk) => kiosk.authorized)
  const unauthorizedKiosks = kiosksState.kioskSuggestions?.filter((kiosk) => kiosk.authorized === false)
  let filteredSuggestions = kiosksState.kioskSuggestions
  if (kiosksState.filterByAuthorized === 'true') {
    filteredSuggestions = authorizedKiosks
  } else if (kiosksState.filterByAuthorized === 'false') {
    filteredSuggestions = unauthorizedKiosks
  }
  return (
    <>
      {kiosksState.kioskSuggestions && (
        <div style={{ maxWidth: '31rem' }}>
          <Autosuggest
            key={`temple-kiosk-picker-${kiosksState.filterByAuthorized}`}
            id="temple-kiosk-picker"
            inputText={kiosksState.kioskInputText}
            onInputTextChange={(e) => kiosksActions.setKioskInputText(e)}
            suggestions={filteredSuggestions}
            onSuggestionSelected={(selection) => {
              selection &&
                kiosksActions.setSelectedKiosk(
                  kiosksState.kiosks.find((kiosk) => kiosk.kioskId === selection.secondaryText)
                )
            }}
            onClear={() => kiosksActions.setSelectedKiosk()}
            placeholder={t('temple.kiosk.selectKiosk', 'Select Kiosk')}
            highlightMatchingText
            clearable
          />
        </div>
      )}
    </>
  )
}
